export const GET_MARRIAGE_CERTIFICATE = 'MARRIAGE_CERTIFICATE/get_marriage_certificate';
export const GET_IMAGE = 'MARRIAGE_CERTIFICATE/GET_IMAGE';
export const UPLOAD_NEW_IMAGE = 'MARRIAGE_CERTIFICATE/UPLOAD_NEW_IMAGE';
export const UPDATE_NEW_IMAGE = 'MARRIAGE_CERTIFICATE/UPDATE_NEW_IMAGE';
export const SYNC_TO_ES = 'MARRIAGE_CERTIFICATE/SYNC_TO_ES';
export const GET_SINGLE_MARRIAGE_CERTIFICATE =
  'MARRIAGE_CERTIFICATE/get_single_marriage_certificate';
export const UPDATE_MARRIAGE_CERTIFICATE =
  'MARRIAGE_CERTIFICATE/update_user-_management';
export const CREATE_MARRIAGE_CERTIFICATE = 'MARRIAGE_CERTIFICATE/create_marriage_certificate';
export const REMOVE_MARRIAGE_CERTIFICATE =
  'MARRIAGE_CERTIFICATE/remove_marriage_certificate';

export const GET_ROLE_LIST = 'ROLE/get_role_list';

export const FORM_DATA = {
  first_name: '',
  last_name: '',
  middle_name: '',
  date_marriage: '',
  registry_number: '',
};

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR', value: 'JR' },
  { label: 'SR', value: 'SR' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
  { label: 'XI', value: 'XI' },
  { label: 'XII', value: 'XII' },
  { label: 'XIII', value: 'XIII' },
  { label: 'XIV', value: 'XIV' },
  { label: 'XV', value: 'XV' },
  { label: 'XVI', value: 'XVI' },
  { label: 'XVII', value: 'XVII' },
  { label: 'XVIII', value: 'XVIII' },
  { label: 'XIX', value: 'XIX' },
  { label: 'XX', value: 'XX' },
];

export const GET_REGION = 'OVRS/get_regions';
export const GET_PROVINCE = 'OVRS/get_provinces';
export const GET_MUNICIPALITIES = 'OVRS/get_municipalities';
export const GET_BARANGAYS = 'OVRS/get_barangays';
